/** LaunchDarkly constants shared by the web and native providers. */

/**
 * The single user key every guest shares while `identify-guest-contexts` is
 * off, and the key both SDKs bootstrap on. Not a valid randomization unit.
 */
export const ANONYMOUS_CONTEXT_KEY = 'anonymous';

/**
 * Whether each guest gets its own identity, keyed by the RudderStack anonymous
 * ID, or all guests share `ANONYMOUS_CONTEXT_KEY`. Off is the default and the
 * outage fallback. Deliberately not platform-targetable.
 */
export const IDENTIFY_GUEST_CONTEXTS_FLAG = 'identify-guest-contexts';

/** Seconds either SDK gets to produce a fresh flag value before giving up. */
export const INITIALIZATION_TIMEOUT_SECONDS = 5;
